import { usePageTitle } from '../hooks/usePageTitle'

const DisclaimerPage = () => {
    usePageTitle('Disclaimer | Quinexa')
    return (
        <main className="main">
            <div className="container">
                <section className="policy-page">
                    <div className="policy-card">
                        <h1 className="policy-title">Disclaimer</h1>
                        <p className="policy-date">Last updated: March 2026</p>

                        <div className="policy-content">
                            <h2>Important Notice</h2>
                            <p>
                                <strong>Quinexa is a social gaming platform for entertainment purposes only.</strong>
                                Please read this disclaimer carefully before using our services.
                            </p>

                            <h2>No Real Money</h2>
                            <p>
                                Quinexa does not involve real money in any way. Key points:
                            </p>
                            <ul>
                                <li>You cannot deposit real money into Quinexa</li>
                                <li>You cannot win real money on Quinexa</li>
                                <li>You cannot withdraw real money from Quinexa</li>
                                <li>Virtual Credits have no monetary value whatsoever</li>
                                <li>Virtual Credits cannot be exchanged for cash or prizes</li>
                            </ul>

                            <h2>Virtual Credits</h2>
                            <p>
                                All Credits on Quinexa are virtual and exist solely for entertainment purposes.
                                These Credits:
                            </p>
                            <ul>
                                <li>Are provided free of charge to new users</li>
                                <li>Cannot be purchased with real money</li>
                                <li>Cannot be sold or transferred to other users</li>
                                <li>Have no value outside of the Quinexa platform</li>
                                <li>May be modified or reset at any time by Quinexa</li>
                            </ul>

                            <h2>Not Gambling</h2>
                            <p>
                                Quinexa is NOT a gambling platform. Our games are designed purely for entertainment
                                and social interaction. There are no real stakes, no real winnings, and no financial risk
                                involved.
                            </p>

                            <h2>Age Restriction</h2>
                            <p>
                                You must be 18 years of age or older to use Quinexa. By using our platform, you confirm
                                that you meet this requirement. If you are under 18, please exit the site immediately.
                            </p>

                            <h2>Entertainment Only</h2>
                            <p>
                                All games on Quinexa are provided for entertainment purposes only. Game outcomes are
                                determined by random number generators and are meant to simulate gaming experiences without
                                any real-world consequences.
                            </p>

                            <h2>No Warranties</h2>
                            <p>
                                Quinexa is provided "as is" without any warranties, express or implied. We do not
                                guarantee:
                            </p>
                            <ul>
                                <li>Uninterrupted access to our platform</li>
                                <li>Error-free operation of games</li>
                                <li>Preservation of game data or Credits</li>
                                <li>Compatibility with all devices or browsers</li>
                            </ul>

                            <h2>Limitation of Liability</h2>
                            <p>
                                Quinexa and its operators shall not be liable for any direct, indirect, incidental,
                                consequential, or punitive damages arising from your use of the platform.
                            </p>

                            <h2>Responsible Gaming</h2>
                            <p>
                                While Quinexa does not involve real money, we encourage responsible use of our platform.
                                If you feel that gaming is negatively impacting your life, please take a break and seek
                                appropriate support.
                            </p>

                            <h2>Contact</h2>
                            <p>
                                If you have any questions about this disclaimer, please contact us at <a
                                    href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                    data-cfemail="c5acaba3aa85b6adaaa0a2a4a8a0b6eba6aaa8">info@quinexa.org.</a>.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default DisclaimerPage